<template>
  <div class="crud_form_wrapper">
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.add_operation") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #233076">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>

    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <base-image-upload-input
            col="12"
            identifier="operation_image"
            :placeholder="$t('PLACEHOLDERS.image')"
            @selectImage="selectImage"
          />

          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.titleAr')"
            v-model.trim="data.title_ar"
            required
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.titleEn')"
            v-model.trim="data.title_en"
            required
          />
          <base-text-editor
            col="6"
            :placeholder="$t('PLACEHOLDERS.descAr')"
            v-model="data.description_ar"
            required
          />
          <base-text-editor
            col="6"
            :placeholder="$t('PLACEHOLDERS.descEn')"
            v-model="data.description_en"
            required
          />

          <div class="btn_wrapper">
            <base-button
              class="mt-2"
              styleType="primary_btn"
              :btnText="$t('BUTTONS.save')"
              :isLoading="isWaitingRequest"
              :disabled="isWaitingRequest"
            />
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: "CreateOperation",

  data() {
    return {
      isWaitingRequest: false,
      data: {
        image: { path: null, file: null },
        title_ar: null,
        title_en: null,
        description_ar: null,
        description_en: null,
      },
    };
  },

  methods: {
    selectImage(selectedImage) {
      this.data.image = selectedImage;
    },
    validateFormInputs() {
      this.isWaitingRequest = true;
      this.submitForm();
    },
    async submitForm() {
      const REQUEST_DATA = new FormData();
      REQUEST_DATA.append("title[ar]", this.data.title_ar || "");
      REQUEST_DATA.append("title[en]", this.data.title_en || "");
      REQUEST_DATA.append("description[ar]", this.data.description_ar || "");
      REQUEST_DATA.append("description[en]", this.data.description_en || "");
      if (this.data.image.file) {
        REQUEST_DATA.append("image", this.data.image.file);
      }

      try {
        await this.$axios({
          method: "POST",
          url: "operations",
          data: REQUEST_DATA,
        });
        this.$message.success(this.$t("MESSAGES.addedSuccessfully"));
        this.$router.push({ path: "/operations/all" });
      } catch (error) {
        this.$message.error(
          error?.response?.data?.message || "Failed to add operation"
        );
      } finally {
        this.isWaitingRequest = false;
      }
    },
  },
};
</script>
